const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppointmentDetailsRow.tsx';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { getPatAppSettings } from 'App/utils/generalUtils';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';

type AppointmentDetailsRowProps = {
    appointment: StructuredAppointment;
};

export const AppointmentDetailsRow = (props: AppointmentDetailsRowProps) => {
    const { appointment } = props;
    const settings = getPatAppSettings();

    return (
        <Grid size={{ xs: 12 }}>
            <Typography>{settings.hospitalLongName}</Typography>
            <Typography>{appointment.RESNAME}</Typography>
        </Grid>
    );
};
